import * as marietta from '../..';
import { ItemLayer } from '.';

export default class RoofLayer extends ItemLayer {
  /**
     * 全てのアイテムの移動
     * @moveX Number X軸移動距離
     * @moveY Number Y軸移動距離
     * */
  moveAllItems(moveX: number, moveY: number): void {
    let target: marietta.webcad.item.Roof;
    for (let i: number = 0; i < this.childList.length; i += 1) {
      target = this.childList[i] as marietta.webcad.item.Roof;
      target.moveDots(moveX, moveY);
    }
  }
}
